<template>
  <div class="IriadeEVAInputFormBlock my-10 px-10">
    <h3 style="text-align: center">{{input.label}}</h3>
    <div class="py-4">
      <v-slider class="mt-5"
                step="1"
                thumb-label
                ticks="always"
                tick-size="2"
                :tick-labels="range(input.config.range[0], input.config.range[1])"
                :min="input.config.range[0]"
                :max="input.config.range[1]"
                v-model="sliderValue"
                @change="$emit('input', sliderValue)"></v-slider>
      <p v-if="errors"
         class="error--text">{{errors[0]}}</p>
      <div class="mt-5"
           style="display: flex; justify-content: space-evenly">
        <IriadeButton style="font-size: 150%"
                      large
                      @click="decrement">-
        </IriadeButton>
        <IriadeButton style="font-size: 150%"
                      large
                      @click="increment">+
        </IriadeButton>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
  import IriadeFormBlockMixin from './IriadeFormBlockMixin'

  export default {
    mixins: [IriadeFormBlockMixin],

    data () {
      return {
        sliderValue: this.input.config.default
      }
    },

    methods: {
      range (start, end) {
        return (new Array(end - start + 1)).fill(undefined).map((_, i) => i + start)
          .map(i => String(i))
      },

      decrement () {
        if (this.sliderValue > this.input.config.range[0]) {
          this.sliderValue--
          this.$emit('input', this.sliderValue)
        }
      },

      increment () {
        if (this.sliderValue < this.input.config.range[1]) {
          this.sliderValue++
          this.$emit('input', this.sliderValue)
        }
      },
    },

    mounted () {
      this.$emit('input', this.input.config.default)
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .IriadeEVAInputFormBlock {

  }
</style>
